import React, { Component } from "react";
import { connect } from "react-redux";
import LOOKUP from "constants/lookup";
import GenericTable from "screens/components/advanced/GenericTable";
import Pagination from "screens/components/basic/Pagination";
import CardSimple from "screens/components/basic/CardSimple";
import { getRoles, deleteRole, updateHiddenRoles } from "actions/EntityActions";
import { userRoleListCrumb } from "utils/breadcrumbInfo";
import { mapRolesList } from "utils/mappers";
import Grid from "screens/components/basic/Grid";
import Button from "screens/components/basic/Button";
import DialogInput from "screens/components/advanced/DialogInput";
import WithRouter from "custom/withRouter";
import PageHeaderWithButton from "screens/components/basic/PageHeaderWithButton";
import DialogHeaderWithClose from '../../../components/basic/DialogHeaderWithClose';

const pageName = "userRoleList";
class UserRoleList extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      activePage: 1,
      itemsPerPage: 25,
      status: "None",
      orderBy: "DESC",
      sortBy: "Id",
      openDeleteDialog: false
    };
    this.editUserRole = this.editUserRole.bind(this);
  }

  //Call the init which will call API to retrive the list of patients
  componentWillMount() {
    this.props.getRoles();
  }

  componentDidUpdate(prevProps) {
    if (this.props.saveSuccess && this.props.saveSuccess != prevProps.saveSuccess) {
      window.location.reload();
    }
  }

  getRoles = () => {
    this.props.init({
      page: this.state.activePage,
      itemsPerPage: this.state.itemsPerPage,
      orderBy: this.state.orderBy,
      sortBy: this.state.sortBy
    });
  }

  createNewRole = () => {
    this.props.navigate(`/userrole/add`);
  }

  editUserRole = (id) => {
    this.props.navigate(`/userrole/edit/${id}`);
  };

  closeDeleteRoleDialog = () => {
    this.setState({
      openDeleteDialog: false
    })
  }

  confirmDeleteRole = (id) => {
    this.setState({
      openDeleteDialog: true,
      selectedRoleId: id
    })
  }

  deleteRole = () => {
    this.props.deleteRole(this.state.selectedRoleId);
  }

  updateHiddenRoles = (item) => {
    if (item.isVisible) {
      this.props.updateHiddenRoles({ roleIdToAdd: item.id });
    } else {
      this.props.updateHiddenRoles({ roleIdToRemove: item.id });
    }
  }

  render() {
    const p = this.props;
    const s = this.state;
    return (
      <Grid headerContent={userRoleListCrumb}>
        <PageHeaderWithButton title={LOOKUP.userRole.listTitle}>
          <Button
            style={{ marginLeft: "1em" }}
            type="AddButton"
            mini={true}
            label="ADD NEW ROLE"
            className="bg-light-green"
            onTouchTap={() => this.props.navigate("/userrole/add")}
          />
        </PageHeaderWithButton>
        <CardSimple>
          <GenericTable
            multiSelectable={false}
            enableSelectAll={false}
            selectable={false}
            columns={LOOKUP.userRole.tableColumns}
            rows={mapRolesList(p.rolesList, this.editUserRole, this.confirmDeleteRole, this.updateHiddenRoles)}
            orderBy={this.state.orderBy}
            sortBy={this.state.sortBy}
            sort={this.sort}
            stripedRows={true}
          />
          <Pagination
            length={p.rolesList ? p.rolesList.length : 0}
            itemsPerPage={s.itemsPerPage}
            activePage={s.activePage}
            onPageChange={this.changePage}
            maxButtons={4}
          />
        </CardSimple>
        <DialogInput
          title={<DialogHeaderWithClose text="Delete Role" classicClass="posDialogClassic" handleClose={() => this.closeDeleteRoleDialog()} />}
          actions={[
            <Button
              key={1}
              type="CancelButton"
              name="buttonCancelRemoveItem"
              className="btn-space btnCancelOperation"
              label={LOOKUP.common.cancel.text}
              onTouchTap={() => this.closeDeleteRoleDialog()} />,
            <Button
              key={2}
              name="buttonRemoveItem"
              label="Confirm"
              className="btnNewBrandPOS"
              primary={true}
              onTouchTap={() => this.deleteRole()} />]}
          modal={true}
          open={this.state.openDeleteDialog}>
          Are you sure you want to delete the role?
        </DialogInput>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    rolesList: state.entity.rolesList ? state.entity.rolesList.filter(_ => _.name != "StoreOwner") : [],
    saveSuccess: state.entity.saveSuccess || null,
    saveError: state.entity.saveError || null
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getRoles: () => dispatch(getRoles()),
    deleteRole: (id) => dispatch(deleteRole(id)),
    getHiddenRoles: (id) => dispatch(getHiddenRoles()),
    updateHiddenRoles: (id) => dispatch(updateHiddenRoles(id))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(UserRoleList));
